import { FC } from "react";
import styles from "./styles.module.css";

interface Props {
  margin?: boolean;
  visible?: boolean;
}

const Divider: FC<Props> = ({ margin = true, visible = true }) => {
  const classes = [styles.dividerRoot, margin && styles.margin, visible && styles.visible].filter(Boolean).join(" ");
  return <hr className={classes} />;
};

export default Divider;
